const mandDoclistItemText = {
  expiration: 'Days Remaining'
};

export default mandDoclistItemText;
